import { Container, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { FC, useEffect, useRef, useState } from 'react'
import useTranslate from '../i18n/useTranslate'
import { useSettingCertificate, FileType } from '../services/um/useSettingCertificate'
import useAuthenStore from '../stores/authen/authenStore'
import Form from './../component/um/settingCertificate/Form'
import Dialog, { DialogType } from '../control/dialog/dialog'
import { useHistory } from 'react-router'

export type CertificateFormProps = {
    certificateID?: number | null
    detail_TH?: string
    detail_EN?: string
    condition_TH?: string
    condition_EN?: string
    imgUpload_th: string | null
    imgUpload_en: string | null
    detail_exempt_TH?: string | null
    detail_exempt_EN?: string | null
    condition_exempt_TH?: string | null
    condition_exempt_EN?: string | null
}

export type LanguageType = 'th' | 'en'

const SettingCertificate = () => {
    const translate = useTranslate()
    const classes = useStyles()
    const { getSettingCertificate, putSettingCertificate, postSettingCertificate } = useSettingCertificate()
    const authenStore = useAuthenStore()
    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()
    const [initialValues, setInitialValues] = useState<CertificateFormProps>({
        imgUpload_th: null,
        imgUpload_en: null,
    })

    useEffect(() => {
        if (authenStore.profile.userId) {
            getSettingCertificateed(authenStore.profile.userId)
        }
    }, [authenStore.profile.userId])

    const getSettingCertificateed = async (userID: number) => {
        let dataList = await getSettingCertificate(userID)

        setInitialValues({
            certificateID: dataList.certificateID || null,
            detail_TH: dataList.description['th'] || '',
            detail_EN: dataList.description['en'] || '',
            condition_TH: dataList.condition['th'] || '',
            condition_EN: dataList.condition['en'] || '',
            imgUpload_th: `${process.env.REACT_APP_UPLOAD}${dataList.logoURL['th']}` || null,
            imgUpload_en: `${process.env.REACT_APP_UPLOAD}${dataList.logoURL['en']}` || null,
            detail_exempt_TH: dataList.descriptionExempt['th'] || '',
            detail_exempt_EN: dataList.descriptionExempt['en'] || '',
            condition_exempt_TH: dataList.conditionExempt['th'] || '',
            condition_exempt_EN: dataList.conditionExempt['en'] || '',
        })
    }

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    const onSave = async (values: any) => {
        let dataList = await getSettingCertificate(authenStore.profile.userId ?? 0)

        if (!dataList.certificateID) {
            const param = {
                description: {
                    th: values.detail_TH || '',
                    en: values.detail_EN || '',
                },
                condition: {
                    th: values.condition_TH || '',
                    en: values.condition_EN || '',
                },
                imgUpload_th: values.imgUpload_th || [],
                imgUpload_en: values.imgUpload_en || [],
                descriptionExempt: {
                    th: values.detail_exempt_TH || '',
                    en: values.detail_exempt_EN || '',
                },
                conditionExempt: {
                    th: values.condition_exempt_TH || '',
                    en: values.condition_exempt_EN || '',
                },
            }

            let result = await postSettingCertificate(param)

            if (result.message === 'success') {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
                    type: 'alert-message',
                })
            }
        } else {
            const param = {
                certificateID: values?.certificateID ?? null,
                description: {
                    th: values.detail_TH || '',
                    en: values.detail_EN || '',
                },
                condition: {
                    th: values.condition_TH || '',
                    en: values.condition_EN || '',
                },
                imgUpload_th: values.imgUpload_th || [],
                imgUpload_en: values.imgUpload_en || [],
                userID: Number(authenStore.profile.userId),
                descriptionExempt: {
                    th: values.detail_exempt_TH || '',
                    en: values.detail_exempt_EN || '',
                },
                conditionExempt: {
                    th: values.condition_exempt_TH || '',
                    en: values.condition_exempt_EN || '',
                },
            }

            let result = await putSettingCertificate(param)

            if (result.message === 'success') {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
                    type: 'alert-message',
                })
            }
        }
    }

    const handleClickSubmit = async (values: CertificateFormProps) => {
        setConfigDialog({
            title: translate.get('ALERT.TITLE.NOTIFICATION'),
            content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
            type: 'alert-confirm',
            onClickConfirm: () => onSave(values),
        })

        dialogTwoRef.current?.openDialog()
    }

    return (
        <Container maxWidth="lg">
            <Grid className={classes.root}>
                <Form onSubmit={handleClickSubmit} initialValues={initialValues} />
                <Dialog onRef={onRefDialogTwo} {...configDialog} />
            </Grid>
        </Container>
    )
}

export default SettingCertificate

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
}))
